import React from 'react'
import PropTypes from 'prop-types'
import { Link, ThemeProvider } from '@deseretbook/react-ui'

/**
 * Video Discovery view for channels inside a channel
 *
 * @param {string} id Channel ID
 * @param {string} image URL to channel image
 * @param {string} error Error sent when Channel not found. Should only show for admin users
 *
 * @returns {function} React Component
 */
export const ChannelView = ({ id, image, name, error }) => {
  if (error) {
    return <div>{error}</div>
  }

  return (
    <ThemeProvider>
      <Link href={`/video/discover/${id}?per_page=30`} aria-label={name}>
        <img src={image} alt={name} width="100%" height="200%" />
      </Link>
    </ThemeProvider>
  )
}

ChannelView.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.string,
}
